import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  Icon,
  InputAdornment,
  TextField
} from "@mui/material";
import React from "react";

function Counter({ data, ind, index, error, textValue, handleTextValue }) {
  const componentName = data?.component?.sName;
  const options = data?.component?.options || {};
  const values = textValue || {};
  const hasCommittedValue = Object.prototype.hasOwnProperty.call(values, componentName);
  const checked = hasCommittedValue
    ? values[componentName] === options.enabledValue
    : options.sDefaultValue === "Yes";

  const handleCheckboxChange = event => {
    const valueChangeEvent = {
      target: {
        value: event.target.checked ? options.enabledValue : "",
        name: componentName
      }
    };

    handleTextValue(valueChangeEvent, ind, data?.validation);
  };

  return (
    <>
      <Grid item {...data?.grid_props}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <TextField
            sx={{ width: "100%" }}
            {...data?.component?.sProps}
            id={data?.component?.sName}
            label={data?.component?.sLabel}
            placeholder={data?.component?.sPlaceHolder}
            helperText={error?.[data?.component?.sName] || data?.component?.sHelper}
            variant={data?.component?.sProps?.variant}
            type={data?.component?.sAdornType}
            value={
              values[componentName] && values[componentName]?.length > 0
                ? values[componentName]
                : "" ||
                  data?.validation?.sType === "COUNTER" ||
                  data?.validation?.sType === "FIXVALUE"
                ? data?.component?.sDefaultValue
                : ""
            }
            name={data?.component?.sName}
            onChange={e => handleTextValue(e, ind, data?.validation)}
           
            disabled={options.mode === "DEFAULT" ? true : checked}
            error={error && error[data?.component?.sName]}
            InputProps={
              data?.component?.sAdornPosition === "start"
                ? {
                    startAdornment: (
                      <>
                        {data?.component?.sAdornPosition &&
                          data?.component?.sAdornType === "icon" && (
                            <InputAdornment position={data?.component?.sAdornPosition}>
                              <Icon iconName={data?.component?.sIcon?.slice(0, -4)} />
                            </InputAdornment>
                          )}
                        {data?.component?.sAdornPosition &&
                          data?.component?.sAdornType === "text" && (
                            <InputAdornment position={data?.component?.sAdornPosition}>
                              {data?.component?.sIcon}
                            </InputAdornment>
                          )}
                      </>
                    )
                  }
                : {
                    endAdornment: (
                      <>
                        {data?.component?.sAdornPosition &&
                          data?.component?.sAdornType === "icon" && (
                            <InputAdornment position={data?.component?.sAdornPosition}>
                              <Icon iconName={data?.component?.sIcon.slice(0, -4)} />
                            </InputAdornment>
                          )}
                        {data?.component?.sAdornPosition &&
                          data?.component?.sAdornType === "text" && (
                            <InputAdornment position={data?.component?.sAdornPosition}>
                              {data?.component?.sIcon}
                            </InputAdornment>
                          )}
                      </>
                    )
                  }
            }
            // {...data?.component?.sProps}
          />
          {options.mode === "TOGGLE" && (
            <FormControlLabel
              {...data?.component?.sProps}
              sx={{
                marginLeft: '0px !important',
                marginRight: '0px !important',
                ...data?.component?.sProps?.sx,
                marginTop: "-30px"
              }}
              control={<Checkbox id={data?.component?.sName+'-checkbox'} checked={checked} onChange={handleCheckboxChange} />}
              label={options.sLabel}
              id={data?.component?.sName+'-label'}
            />
          )}
        </Box>
        {/* {error && <p style={{ color: "red" }}>{error && error[data?.component?.sName]}</p>} */}
      </Grid>
    </>
  );
}

export default Counter;
